import { AppModule } from '@app/types';

export const ContentAiModule: AppModule = {
  id: 'contentAi',
  title: 'Content AI',
  basePath: 'content-ai',
};
